// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".has-overlay[data-v-ac28bbb0]:before{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;display:block;width:100%;height:100%;content:\"\";background-color:#000;opacity:.5;transition:opacity .3s}.gradient[data-v-ac28bbb0]:before{background-color:transparent;background-image:linear-gradient(180deg,rgba(0,0,0,.2) 0,rgba(0,0,0,.8));opacity:1}", ""]);
// Exports
module.exports = exports;
